import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=59e10b4e&scoped=true"
import script from "./updata.vue?vue&type=script&lang=js"
export * from "./updata.vue?vue&type=script&lang=js"
import style0 from "./updata.vue?vue&type=style&index=0&id=59e10b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e10b4e",
  null
  
)

export default component.exports